<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'
import SignaturePad from 'src/vendor/signature_pad'

export default {
  name: 'signature',
  props: {
    value: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapState({
      venue: (state) => state.venue.current,
    }),
  },
  data() {
    return {
      signaturePad: null,
    }
  },
  methods: {
    clear() {
      this.signaturePad.clear()

      this.$emit('input', null)
      this.$emit('change', null)
    },
    validate() {
      return !this.signaturePad.isEmpty()
    },
    onWindowResize() {
      const ratio = Math.max(window.devicePixelRatio || 1, 1)

      this.$refs.canvasEl.width = this.$refs.canvasEl.offsetWidth * ratio
      this.$refs.canvasEl.height = this.$refs.canvasEl.offsetHeight * ratio
      this.$refs.canvasEl.getContext('2d').scale(ratio, ratio)

      this.signaturePad.clear() // otherwise isEmpty() might return incorrect value

      if (this.value) {
        setTimeout(() => {
          this.signaturePad.fromDataURL(this.value)
        }, 500)
      }
    },
  },
  mounted() {
    this.$refs.canvasEl.height = this.$refs.canvasEl.offsetHeight
    this.$refs.canvasEl.width = this.$refs.canvasEl.offsetWidth

    this.signaturePad = new SignaturePad(this.$refs.canvasEl, {
      backgroundColor: 'rgb(255, 255, 255)',
      onEnd: () => {
        const val = this.signaturePad.toDataURL('image/png')

        this.$emit('input', val)
        this.$emit('change', val)
      },
    })

    if (this.value) {
      this.signaturePad.fromDataURL(this.value)
    }

    window.addEventListener('resize', this.onWindowResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.onWindowResize)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Signature/index.vue